// import React, { useState } from 'react';
// import { Box, Tabs, Tab } from '@mui/material';
// import Header from './Header.tsx';
// import LeadsSection from './LeadsSection.tsx';
// import DetailsSection from './DetailsSection.tsx';
// import UserSection from './UserSection.tsx';

// const MobileLeadLayout = (props) => {
//   const { updateUserDetail } = props; 
//   const [tab, setTab] = useState(0);

//   return (
//     <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>

//       {/* FIXED HEADER */}
//       <Box sx={{ position: 'sticky', top: 0, zIndex: 10, bgcolor: '#fff' }}>
//         <Header />
//       </Box>

//       {/* TAB CONTENT - Changed: removed p: 1, added pb for tab clearance */}
//       <Box sx={{ flex: 1, overflowY: 'auto', pb: '56px' }}>
//         {tab === 0 && <LeadsSection onLeadClick={() => setTab(1)} />}
//         {tab === 1 && <DetailsSection {...props} />}
//         {tab === 2 && <UserSection {...props} />}
//       </Box>

//       {/* BOTTOM TABS - Changed: Added fixed positioning */}
//       <Box sx={{ 
//         position: 'fixed', 
//         bottom: 0, 
//         left: 0, 
//         right: 0, 
//         bgcolor: '#fff',
//         borderTop: '1px solid #e0e0e0',
//         zIndex: 10
//       }}>
//         <Tabs value={tab} onChange={(e, v) => setTab(v)} variant="fullWidth">
//           <Tab label="Leads" />
//           <Tab label="Details" />
//           <Tab label="User" />
//         </Tabs>
//       </Box>
//     </Box>
//   );
// };


// export default MobileLeadLayout;

import React, { useState } from 'react';
import {
  Box,
  Button,
  Grid,
  Paper,
  Typography,
  Fab,
  IconButton,
} from '@mui/material';
import KeyboardVoiceOutlinedIcon from '@mui/icons-material/KeyboardVoiceOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import MessageOutlinedIcon from '@mui/icons-material/MessageOutlined';
import CloseIcon from '@mui/icons-material/Close';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import DynamicFormFieldsList from '../Leads/DynamicFormFields/List.tsx';
import CommentBox from '../Shared/CommentBox/index.tsx';
import { useRecoilValue, useRecoilState, useSetRecoilState } from 'recoil';
import {
  userInformationAtom,
  userDetailAtom,
  leadDetailObjAtom,
  userInfoByNumberAtom,
  dynamicLeadFormAtom,
  campaignLeadManagementAtom,
  formEnableDisableAtom,
} from '../../Services/_states';
import { LeadFormActions } from '../../Services/_actions';
import { useSnackBar } from '../FlowBuilder/Common/SnackBar/index.tsx';
import {
  BLOCKED_EXTENSIONS,
  WHATSAPP_ALLOWED_MIME,
  WHATSAPP_LIMITS,
} from '../Whatsapp/Template/template.constant.js';
import ModalForms from '../Shared/Modals';
import { ImageModal } from '../Modals/ImageModal/index';
import { AudioModal } from '../Modals/AudioModal/index';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { useParams } from 'react-router';
import LeadsDropdown from '../Shared/WebFormLeadsDrodown/index.tsx';
import { groupLeadItems, staticColumnsMatch } from '../Leads/DynamicFormFields/helper.ts';
import Header from './Header.tsx';

interface MobileLeadLayoutProps {
  dynamicFormData: any;
  handleFieldChange: (index: number, value: any, groupTitle: string) => void;
  fieldErrors: any;
  loggedInUser: any;
  phoneNumber: string;
  formEnable: boolean;
  isLoading: boolean;
  editForms: () => void;
  validateFormData: () => void;
  setShowQuickTempModal: (show: boolean) => void;
  setDispositionModalShow: (show: boolean) => void;
  leadFormTemplate: any[];
  setAudioModalShow: (show: boolean) => void;
  setModalShow_call: (show: boolean) => void;
  setModalShow_temp: (show: boolean) => void;
  setShowChatBox: (show: boolean) => void;
  showChatBox: boolean;
}

const MobileLeadLayout: React.FC<MobileLeadLayoutProps> = ({
  dynamicFormData,
  handleFieldChange,
  fieldErrors,
  loggedInUser,
  phoneNumber,
  formEnable,
  isLoading,
  editForms,
  validateFormData,
  setShowQuickTempModal,
  setDispositionModalShow,
  leadFormTemplate,
  setAudioModalShow,
  setModalShow_call,
  setModalShow_temp,
  setShowChatBox,
  showChatBox,
}) => {
  const leadFormActions = LeadFormActions();
  const { showSnackBar } = useSnackBar();
  const [showIcons, setShowIcons] = useState(false);
  // const [leadDetails] = useRecoilState(leadDetailObjAtom);
  const [imagesList, setImagesList] = useState<any[]>([]);
  const [audioList, setAudioList] = useState<any[]>([]);
  const [commentList, setCommentList] = useState<any[]>([]);
  const [modalShow, setModalShow] = useState(false);
  const [audioModalShow, setAudioModalShowLocal] = useState(false);
  const leadDetails = useParams();
  const [selectedLead, setSelectedLead] = useState<any>(null);
  const [userDetailByNumber, setUserDetailByNumber] = useRecoilState(userInfoByNumberAtom);
  const [leadDetail, setLeadDetail] = useRecoilState(leadDetailObjAtom);
  const setUserDetail = useSetRecoilState(userDetailAtom);
  const setFormEnable = useSetRecoilState(formEnableDisableAtom);
  const [campaignLeadManagementData, setCampaignLeadManagementData] = useRecoilState(
    campaignLeadManagementAtom
  );
  const [dynamicLeadForm, setDynamicLeadForm] = useRecoilState(dynamicLeadFormAtom);
  const inferDocType = (mime: string) => {
    if (WHATSAPP_ALLOWED_MIME.image.includes(mime)) return 'image';
    if (WHATSAPP_ALLOWED_MIME.video.includes(mime)) return 'video';
    if (WHATSAPP_ALLOWED_MIME.audio.includes(mime)) return 'audio';
    if (WHATSAPP_ALLOWED_MIME.file.includes(mime)) return 'file';
    return null;
  };


  const bytesToMB = (bytes: number) => (bytes / (1024 * 1024)).toFixed(2);

  const getStatusList = async (leadFormId: string) => {
    try {
      const payload = {
        active: { value: true },
        leadFormId: leadFormId,
      };

      const res = await leadFormActions.fetchStatusAndSubStatus(payload);
      if (res?.status === 200) {
        setCampaignLeadManagementData((prev) => ({
          ...prev,
          statusData: {
            ...prev.statusData,
            [leadFormId]: res.data,
          },
        }));
      }
    } catch (error) {
      console.warn(error);
    }
  };

  const processLeadData = (data: any) => {
    try {
      const stored = localStorage.getItem('leadWebFormData');
      if (!stored || !data) return;

      const leadWebFormData = JSON.parse(stored);
      const localData = leadWebFormData?.webForm;
      if (!localData) return;

      setCampaignLeadManagementData((prev) => ({
        ...prev,
        selectedForm: localData ?? null,
        selectedCampaign: leadWebFormData?.campaign ?? null,
      }));

      // ✅ Fetch status list
      if (localData?.leads_form_id) {
        getStatusList(localData.leads_form_id);
      }

      const rawFields =
        localData?.leads_form_items ??
        localData?.data ??
        {};

      const dynamicFormFields = staticColumnsMatch(
        Object.values(rawFields)
      );

      const dynamicFormGroups = localData?.group_options || [];

      const sourceData = data?.data ?? data?.lead_data ?? [];

      const fieldMap = new Map(
        (sourceData || []).map((item) => [item.key_name, item])
      );

      const populated = (dynamicFormFields || []).map((field) => {
        const source = fieldMap.get(field.key_name);

        return {
          ...field,
          value: source?.value ?? field.value ?? '',
          status_config: source?.status_config ?? field.status_config ?? null,
          entity_data: source?.entity_data ?? field.entity_data ?? null,
        };
      });

      const groupedForm = groupLeadItems(populated, dynamicFormGroups);
      setDynamicLeadForm(groupedForm);
    } catch (err: any) {
      showSnackBar(err?.toString() || 'Form process failed', 'error');
    }
  };

  const initBlankFormFromLocalStorage = () => {
    try {
      const stored = localStorage.getItem('leadWebFormData');
      if (!stored) return;
      const leadWebFormData = JSON.parse(stored) || {};
      const localForm = leadWebFormData?.webForm;
      if (!localForm?.leads_form_items && !localForm?.data) return;

      const rawFields = localForm?.leads_form_items ?? localForm?.data ?? {};
      const dynamicFormFields = staticColumnsMatch(Object.values(rawFields));
      const dynamicFormGroups = localForm?.group_options || [];
      const groupedForm = groupLeadItems(dynamicFormFields, dynamicFormGroups);

      setDynamicLeadForm(groupedForm);

      if (leadWebFormData?.campaign?.proposal_id && localForm?.leads_form_id) {
        setUserDetailByNumber((prev) => ({
          ...prev,
          leadform_Id: localForm.leads_form_id,
          campaign_id: leadWebFormData.campaign.proposal_id,
          phone_number: leadWebFormData.phoneNumber || prev?.phone_number || '',
        }));
      }
    } catch (err) {
      console.warn('Error initializing blank form (mobile):', err);
    }
  };

  React.useEffect(() => {
    const handleStorage = () => {
      const stored = localStorage.getItem('leadWebFormData');
      if (stored && selectedLead) {
        const parsed = JSON.parse(stored);
        if (parsed?.webForm) {
          processLeadData(selectedLead);
        }
      }
    };

    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, [selectedLead]);


  const handleFileSelect = async (e: React.ChangeEvent<HTMLInputElement>) => {
    let file = e?.target?.files?.[0];
    if (!file) return;
    const fileName = file?.name?.toLowerCase();
    const ext = fileName.split('.').pop();
    if (BLOCKED_EXTENSIONS.has(ext || '')) {
      showSnackBar(`"${ext}" files are not allowed for security reasons.`, 'error');
      e.target.value = '';
      return;
    }
    const typeGroup = inferDocType(file.type);
    if (!typeGroup) {
      showSnackBar(`Unsupported file type (${file.type || ext}).`, 'error');
      e.target.value = '';
      return;
    }

    const limit = WHATSAPP_LIMITS[typeGroup];
    if (file.size > limit) {
      showSnackBar(
        `File too large for ${typeGroup}. Max ${bytesToMB(limit)} MB. Your file is ${bytesToMB(file?.size)} MB.`,
        'error'
      );
      e.target.value = '';
      return;
    }
    let form = new FormData();
    form.append('file', file);
    await leadFormActions.uploadLeadImageById(leadDetails?.leadId, form);
    showSnackBar('Image uploaded successfully!', 'success');
    e.target.value = '';
  };

  const handleAudioFile = async (event: React.ChangeEvent<HTMLInputElement>) => {
    let file = event?.target?.files?.[0];
    if (!file) return;

    const fileName = file.name.toLowerCase();
    const ext = fileName.split('.').pop();

    if (BLOCKED_EXTENSIONS.has(ext || '')) {
      showSnackBar(`"${ext}" files are not allowed for security reasons.`, 'error');
      event.target.value = '';
      return;
    }

    const typeGroup = inferDocType(file.type);
    if (typeGroup !== 'audio') {
      showSnackBar(
        `Unsupported file type (${file.type || ext}). Please upload an audio file.`,
        'error'
      );
      event.target.value = '';
      return;
    }

    const limit = WHATSAPP_LIMITS.audio;
    if (file.size > limit) {
      showSnackBar(
        `File too large. Max ${bytesToMB(limit)} MB. Your file is ${bytesToMB(file.size)} MB.`,
        'error'
      );
      event.target.value = '';
      return;
    }

    try {
      let form = new FormData();
      form.append('file', file);
      await leadFormActions.uploadLeadAudioById(leadDetails?.leadId, form);
      showSnackBar('Audio uploaded successfully!', 'success');
      event.target.value = '';
    } catch (err) {
      showSnackBar(err?.toString() || 'Upload failed', 'error');
      event.target.value = '';
    }
  };

  const getImagesById = async () => {
    setModalShow(true);
    let res = await leadFormActions.getLeadImagesById(leadDetails?.leadId);
    setImagesList(res?.data?.image_funnel || []);
  };

  const getAudioById = async () => {
    setAudioModalShowLocal(true);
    let res = await leadFormActions.getLeadAudioById(leadDetails?.leadId);
    setAudioList(res?.data?.audio_list || []);
  };

  const getCommentById = async (id: string) => {
    setCommentList([]);
    if (!id) return;
    try {
      let res = await leadFormActions.getCommentById(id);
      setCommentList(res?.data?.internal_comments);
    } catch (err) {
      showSnackBar(err?.toString() || 'Error', 'error');
    }
  };

  const onsubmitComment = async (commentText: string) => {
    try {
      if (commentText) {
        const response = await leadFormActions.postCommentById(
          { comment: commentText, id: leadDetails?.leadId },
          leadDetails?.leadId
        );
        if (response && response.status === 200) {
          setCommentList([
            ...(commentList || []),
            {
              comment: commentText,
              created_at: new Date(),
              created_by: loggedInUser?.username ?? 'You',
            },
          ]);
          showSnackBar('Comment added successfully', 'success');
        } else {
          showSnackBar('Failed to add comment', 'error');
        }
      }
    } catch (error) {
      showSnackBar(error?.toString() || 'Error', 'error');
    }
  };

  React.useEffect(() => {
    if (leadDetails?.leadId) {
      getCommentById(leadDetails.leadId);
    }
  }, [leadDetails?.leadId]);

  return (
    <Box sx={{ pb: 8 }}>
      {/* Fixed Top Actions - Only Quick Actions */}
      <Box
        sx={{
          position: 'sticky',
          top: 0,
          zIndex: 10,
          bgcolor: 'background.paper',
          borderBottom: '1px solid #EAEAEA',
          p: 2,
          mb: 2,
        }}
      >
        <Box sx={{ position: 'sticky', top: 0, zIndex: 10, bgcolor: '#fff', pb: 2 }}>
          <Header />
        </Box>

        <Grid container spacing={1}>
          <Grid item xs={6}>
            <Button
              variant="contained"
              size="small"
              fullWidth
              onClick={() => setDispositionModalShow(true)}
            >
              Disposition
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              variant="contained"
              size="small"
              fullWidth
              onClick={() => setShowQuickTempModal(true)}
              disabled={!leadFormTemplate?.length}
            >
              Quick Template
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Box marginTop="24px">
        <LeadsDropdown
          value={selectedLead}
          onChange={(lead) => {
            setSelectedLead(lead);
            processLeadData(lead);
            setLeadDetail(lead);
            getCommentById(lead?.lead_id || lead?.id);
          }}

          campaignId={userDetailByNumber?.campaign_id}
          leadFormId={userDetailByNumber?.leadform_Id}
          phoneNumber={userDetailByNumber?.phone_number}
          leadId={leadDetails?.leadId}
        />
        <Box mt={1}>
          <Button
            variant="outlined"
            size="small"
            fullWidth
            onClick={() => {
              setSelectedLead(null);
              setLeadDetail({});
              setUserDetail({});
              setFormEnable(false);
              initBlankFormFromLocalStorage();
            }}
          >
            Create Lead
          </Button>
        </Box>
      </Box>
      {/* Scrollable Form Section */}
      <Box
        sx={{
          maxHeight: 'calc(100vh - 280px)',
          overflowY: 'auto',
          px: 2,
          '&::-webkit-scrollbar': {
            width: '6px',
          },
          '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
          },
          '&::-webkit-scrollbar-thumb': {
            background: '#888',
            borderRadius: '3px',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            background: '#555',
          },
        }}
      >
        <DynamicFormFieldsList
          data={dynamicFormData || {}}
          userId={loggedInUser?.id}
          onChange={handleFieldChange}
          fieldErrors={fieldErrors}
          disabled={formEnable}
          phoneNumber={phoneNumber}
          gridSize={12}
        />
      </Box>

      {/* Images and Recordings Section - Below Form */}
      {leadDetails?.leadId && (
        <Box sx={{ px: 2, mt: 3 }}>
          <Paper elevation={2} sx={{ p: 2, border: '1px solid #EAEAEA' }}>
            <Grid container spacing={2}>
              {/* Images */}
              <Grid item xs={12}>
                <Typography variant="subtitle2" sx={{ mb: 1, color: 'text.main', fontWeight: 600 }}>
                  Images
                </Typography>
                <Box
                  sx={{
                    border: '2px dashed #B4B6BA',
                    padding: 2,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    cursor: 'pointer',
                    borderRadius: 1,
                    transition: 'background-color 0.3s ease',
                    '&:hover': { backgroundColor: '#e3f2fd' },
                    flexDirection: 'column',
                    textAlign: 'center',
                    minHeight: '100px',
                  }}
                  onClick={() => document.getElementById('image-upload-mobile')?.click()}
                >
                  <CloudUploadOutlinedIcon sx={{ fontSize: '28px', color: '#1976d2', mb: 1 }} />
                  <input
                    type="file"
                    id="image-upload-mobile"
                    accept="image/png, image/gif, image/jpeg"
                    onChange={handleFileSelect}
                    style={{ display: 'none' }}
                  />
                  <Typography variant="body2">
                    <Box sx={{ fontWeight: '500', fontSize: '14px', color: 'text.main' }}>
                      Choose a file
                    </Box>
                    <span style={{ fontSize: '0.85rem', color: '#616161' }}>
                      Supports JPG, PNG, GIF (Max 5 MB)
                    </span>
                  </Typography>
                </Box>
                <Button
                  variant="contained"
                  size="small"
                  onClick={getImagesById}
                  fullWidth
                  sx={{ mt: 1 }}
                >
                  View Images
                </Button>
              </Grid>

              {/* Recordings */}
              <Grid item xs={12}>
                <Typography variant="subtitle2" sx={{ mb: 1, color: 'text.main', fontWeight: 600 }}>
                  Recordings
                </Typography>
                <Box
                  sx={{
                    border: '2px dashed #B4B6BA',
                    padding: 2,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    cursor: 'pointer',
                    borderRadius: 1,
                    transition: 'background-color 0.3s ease',
                    '&:hover': { backgroundColor: '#e3f2fd' },
                    flexDirection: 'column',
                    textAlign: 'center',
                    minHeight: '100px',
                  }}
                  onClick={() => document.getElementById('audio-upload-mobile')?.click()}
                >
                  <CloudUploadOutlinedIcon sx={{ fontSize: '28px', color: '#1976d2', mb: 1 }} />
                  <input
                    type="file"
                    id="audio-upload-mobile"
                    accept="audio/*"
                    onChange={handleAudioFile}
                    style={{ display: 'none' }}
                  />
                  <Typography variant="body2">
                    <Box sx={{ fontWeight: '500', fontSize: '14px', color: 'text.main' }}>
                      Choose a file
                    </Box>
                    <span style={{ fontSize: '0.85rem', color: '#616161' }}>
                      Supports audio • Max 16 MB
                    </span>
                  </Typography>
                </Box>
                <Button
                  variant="contained"
                  size="small"
                  onClick={getAudioById}
                  fullWidth
                  sx={{ mt: 1 }}
                >
                  View Recordings
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </Box>
      )}

      {/* Comments Section - Below Images/Recordings */}
      <Box sx={{ px: 2, mt: 3, mb: 2 }}>
        <Paper elevation={2} sx={{ p: 2, border: '1px solid #EAEAEA' }}>
          <Typography variant="subtitle2" sx={{ mb: 2, color: 'text.main', fontWeight: 600 }}>
            Comments
          </Typography>
          <CommentBox commentList={commentList} onSubmitComment={onsubmitComment} />
        </Paper>
      </Box>

      {/* Floating Action Buttons - Bottom Right with Save/Edit on top */}
      <Box
        sx={{
          position: 'fixed',
          bottom: 16,
          right: 16,
          zIndex: 1000,
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
        }}
      >
        {/* Save and Edit Icon Buttons - Always Visible */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 1 }}>
          <Fab
            size="small"
            color="primary"
            onClick={validateFormData}
            disabled={isLoading}
            sx={{
              boxShadow: 3,
            }}
          >
            {isLoading ? (
              <Box
                sx={{
                  width: 20,
                  height: 20,
                  border: '2px solid #fff',
                  borderTop: '2px solid transparent',
                  borderRadius: '50%',
                  animation: 'spin 1s linear infinite',
                  '@keyframes spin': {
                    '0%': { transform: 'rotate(0deg)' },
                    '100%': { transform: 'rotate(360deg)' },
                  },
                }}
              />
            ) : (
              <SaveOutlinedIcon />
            )}
          </Fab>
          <Fab
            size="small"
            color="primary"
            onClick={editForms}
            sx={{
              boxShadow: 3,
            }}
          >
            <EditOutlinedIcon />
          </Fab>
        </Box>

        {/* Expandable Action Icons */}
        {showIcons && (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 1 }}>
            <Fab size="small" color="primary" onClick={() => setAudioModalShow(true)}>
              <KeyboardVoiceOutlinedIcon />
            </Fab>
            <Fab size="small" color="primary" onClick={() => setModalShow_call(true)}>
              <LocalPhoneOutlinedIcon />
            </Fab>
            <Fab size="small" color="primary" onClick={() => setModalShow_temp(true)}>
              <SendOutlinedIcon />
            </Fab>
            <Fab size="small" color="primary" onClick={() => setShowChatBox(!showChatBox)}>
              {showChatBox ? <CloseIcon /> : <MessageOutlinedIcon />}
            </Fab>
          </Box>
        )}

        {/* Three Dot Menu Button */}
        <Fab color="primary" onClick={() => setShowIcons(!showIcons)}>
          {showIcons ? <CloseIcon /> : <MoreVertIcon />}
        </Fab>
      </Box>

      {/* Modals */}
      {modalShow && (
        <ModalForms
          show={modalShow}
          handleClose={() => setModalShow(false)}
          modalBody={<ImageModal imagesList={imagesList || []} />}
          modalHeader="Images"
          modalId="Images"
          modalclassName=""
          size=""
        />
      )}

      {audioModalShow && (
        <ModalForms
          show={audioModalShow}
          handleClose={() => setAudioModalShowLocal(false)}
          modalBody={<AudioModal audioList={audioList || []} />}
          modalHeader="Recordings"
          modalId="audioModal"
          modalclassName=""
          size=""
        />
      )}
    </Box>
  );
};

export default MobileLeadLayout;
